// public/js/ui/modals.js
import { createNewAssetModal } from '../features/assets/modals/new-asset-modal.js';
import { createAssignDeviceModal } from '../features/devices/modals/assign-device-modal.js';
import { createPoiModal } from '../features/pois/poi-modal.js';
import { createPoiTypeModal } from '../features/pois/poi-type-modal.js';
import { createDeviceDetailModal } from '../features/devices/components/device-detail-modal.js';

export function createAllModals() {
  createNewAssetModal();        // ← now fully functional
  createAssignDeviceModal();
  createPoiModal();
  createPoiTypeModal();
  createDeviceDetailModal();
  console.log('✅ All modals loaded (new-asset now fully functional)');
}